var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.summary && _vm.summary.html)?_c('div',{staticClass:"C-article-info-summary",domProps:{"innerHTML":_vm._s(_vm.summary.html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }